var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tag",style:(_vm.tagStyles)},[_c('DSTextElement',{style:(_vm.textStyles),attrs:{"variant":"xsmall-medium"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }